import React from "react";
import { useDebridement } from "./hooks/useDebridement";
import ConfirmationModal from "../../../secondary/ConfirmationModal/ConfirmationModal";
import { DebridementEditMode } from "./DebridementEditMode";
import { DebridementViewMode } from "./DebridementViewMode";

const CONFIRMATION_MESSAGE = "All progress in this section will be lost. Are you sure want to cancel?";

export const Debridement = ({ interventionId, assessmentDetails, formularyId }) => {
  const hook = useDebridement({ interventionId, formularyId });

  const sharedOptionProps = {
    debridementperformedbyOptions: hook.debridementperformedbyOptions,
    nonexcisionalapproachOptions: hook.nonexcisionalapproachOptions,
    surgicaldebridementprocedureOptions: hook.surgicaldebridementprocedureOptions,
    depthofdebridementOptions: hook.depthofdebridementOptions,
    instrumentsusedOptions: hook.instrumentsusedOptions,
    necroticsubcutaneoustissueOptions: hook.necroticsubcutaneoustissueOptions,
    necrotictissueOptions: hook.necrotictissueOptions,
    notapplicableOptions: hook.notapplicableOptions,
    postdebridementbleedingamountOptions: hook.postdebridementbleedingamountOptions,
    techniqueusedOptions: hook.techniqueusedOptions,
  };

  return (
    <>
      {hook.confirmationModal && (
        <ConfirmationModal message={CONFIRMATION_MESSAGE} onClose={hook.confirmationClose} onConfirm={hook.yesConfirmationModalClick} />
      )}

      <div>
        {hook.editable ? (
          <DebridementEditMode
            assessmentDetails={assessmentDetails}
            setFormChangesConfirm={hook.setFormChangesConfirm}
            handleSubmit={hook.handleSubmit}
            doSubmit={hook.doSubmit}
            register={hook.register}
            errors={hook.errors}
            resp={hook.resp}
            listOptionsresp={hook.listOptionsresp}
            hideButtons={hook.hideButtons}
            noDataMsg={hook.noDataMsg}
            prodCatCheck={hook.prodCatCheck}
            additionalQuestions={hook.additionalQuestions}
            nonExcisionalShow={hook.nonExcisionalShow}
            nonExcisionalDisabledValues={hook.nonExcisionalDisabledValues}
            deepestLevelCom={hook.deepestLevelCom}
            excisionalDisable={hook.excisionalDisable}
            instrumentsUsed={hook.instrumentsUsed}
            ftNecroticSubcutaneousTissue={hook.ftNecroticSubcutaneousTissue}
            necroticTissueView={hook.necroticTissueView}
            na={hook.na}
            techniqueUsed={hook.techniqueUsed}
            stoppedBleeding={hook.stoppedBleeding}
            customErrors={hook.customErrors}
            surfaceAreaCheck={hook.surfaceAreaCheck}
            instrumentsUsedDefault={hook.instrumentsUsedDefault}
            defaultValNecroticTissue={hook.defaultValNecroticTissue}
            defaultValNecroticSubTissue={hook.defaultValNecroticSubTissue}
            defaultValNotApplicable={hook.defaultValNotApplicable}
            getValue={hook.getValue}
            listViewRef={hook.listViewRef}
            instrumentsUsedRef={hook.instrumentsUsedRef}
            necroticTissueRef={hook.necroticTissueRef}
            notapplicableRef={hook.notapplicableRef}
            onCancelClick={hook.handleCancelClick}
            getPrimaryGroup={hook.getPrimaryGroup}
            surgicalPerformedBy={hook.surgicalPerformedBy}
            debrideProcedureChange={hook.debrideProcedureChange}
            performedExcisionalChange={hook.performedExcisionalChange}
            postBleedingSelect={hook.postBleedingSelect}
            handleListViewMenuChange={hook.handleListViewMenuChange}
            necroticTissueChange={hook.necroticTissueChange}
            instrumentsUsedChange={hook.instrumentsUsedChange}
            notapplicableSelect={hook.notapplicableSelect}
            getOptValue={hook.getOptValue}
            {...sharedOptionProps}
          />
        ) : (
          <DebridementViewMode
            resp={hook.resp}
            listOptionsresp={hook.listOptionsresp}
            assessmentDetails={assessmentDetails}
            hideButtons={hook.hideButtons}
            noDataMsg={hook.noDataMsg}
            onEdit={hook.editMode}
            {...sharedOptionProps}
          />
        )}
      </div>
    </>
  );
};
